<template>
  <div class="member-area-product-students-progress">
    <div>
      <div class="d-flex align-items-center justify-content-between pb-3">
        <h6>Detalhes do Progresso</h6>
        <button class="btn btn-sm btn-square" @click="$emit('close')">
          <i class="icon-x fs-20 text-secondary" />
        </button>
      </div>
      <product-dropdown :product="product" />
      <div class="d-flex align-items-center py-3">
        <small class="mr-3">Progresso no curso</small>
        <b-progress
          :value="selectedStudent.progress"
          max="100"
          class="mr-3 w-25"
        ></b-progress>
        <span style="width: 35px; font-size: 12px;">
          {{ selectedStudent.progress }} %
        </span>
      </div>
      <div class="py-6 centering" v-if="loading">
        <b-spinner variant="primary" />
      </div>
      <ul v-else>
        <li v-for="(item, index) in modules.results" :key="index">
          <div
            id="dropdown-label"
            class="d-flex align-items-center"
            v-b-toggle="item.id"
          >
            {{ item.name }}
            <div class="ml-auto" style="width: 45px;">
              <circle-progress :percentage="item.progress" />
            </div>
          </div>
          <b-collapse :id="item.id">
            <!--Desktop Table-->
            <data-table
              class="d-none d-lg-block px-9"
              :columns="columns"
              :data="item.lessons"
              :firstColumnFr="1.5"
              :lastColumnFr="0.8"
              :newDesign="true"
            >
              <template #default="{ item, i }">
                <div class="d-flex align-items-center crop text-left">
                  <div
                    class="ml-n2 fs-13"
                    style="min-width: 30px; text-align: right;"
                  >
                    {{ i + 1 }}.
                  </div>
                  <span class="ml-2 fs-13">{{ item.name }}</span>
                </div>
                <div class="d-flex align-items-center text-left pt-2 fs-13">
                  {{ item.progress.last_access }}
                </div>
                <div
                  class="d-flex align-items-center text-left pt-2 fs-13"
                  :class="{
                    completed: item.progress.status === 'Completo',
                    ongoing: item.progress.status === 'Em andamento'
                  }"
                >
                  {{ item.progress.status }}
                </div>
              </template>
            </data-table>
            <!--Mobile Table-->
            <data-table
              class="d-lg-none px-5"
              :columns="columns"
              :data="item.lessons"
              :columnsFr="'1fr'"
              :newDesign="true"
            >
              <template #default="{ item, i }">
                <div class="d-flex flex-column text-left pl-2 py-2 lesson">
                  <div class="d-flex justify-content-between pb-2">
                    <strong style="min-width: 55px;">
                      Aula {{ i + 1 }}:
                    </strong>
                    <strong class="ml-3 overflow-hidden text-right">{{
                      item.name
                    }}</strong>
                  </div>
                  <div class="d-flex justify-content-between pb-2">
                    <span class="mr-3">Último acesso:</span>
                    <strong>{{ item.progress.last_access }}</strong>
                  </div>
                  <div class="d-flex justify-content-between">
                    <span class="mr-3">Progresso:</span>
                    <div
                      class="d-flex align-items-center text-left pt-2 "
                      :class="{
                        completed: item.progress.status === 'Completo',
                        ongoing: item.progress.status === 'Em andamento'
                      }"
                    >
                      {{ item.progress.status }}
                    </div>
                  </div>
                </div>
              </template>
            </data-table>
            <div v-if="item.sub_modules.length">
              <ul class="px-lg-5 px-2">
                <li
                  v-for="(subItem, subIndex) in item.sub_modules"
                  :id="subItem.id"
                  :key="subIndex"
                >
                  <div
                    id="dropdown-label"
                    class="d-flex align-items-center submodule"
                    v-b-toggle="subItem.id"
                  >
                    {{ subItem.name }}
                  </div>
                  <b-collapse :id="subItem.id">
                    <!--Desktop Table Submodule-->
                    <data-table
                      class="d-none d-lg-block submodule-table"
                      :columns="columns"
                      :data="subItem.lessons"
                      :firstColumnFr="1.5"
                      :lastColumnFr="0.8"
                      :newDesign="true"
                    >
                      <template #default="{ item, i }">
                        <div class="d-flex align-items-center crop text-left">
                          <div
                            class="ml-n2"
                            style="min-width: 14px; text-align: right;"
                          >
                            {{ i + 1 }}.
                          </div>
                          <span class="ml-2">{{ item.name }}</span>
                        </div>
                        <div class="d-flex align-items-center text-left pt-2">
                          {{ item.progress.last_access }}
                        </div>
                        <div
                          class="d-flex align-items-center text-left pt-2"
                          :class="{
                            completed: item.progress.status === 'Completo',
                            ongoing: item.progress.status === 'Em andamento'
                          }"
                        >
                          {{ item.progress.status }}
                        </div>
                      </template>
                    </data-table>
                    <!--Mobile Table Submodule-->
                    <data-table
                      class="d-lg-none"
                      :columns="columns"
                      :data="subItem.lessons"
                      :columnsFr="'1fr'"
                      :newDesign="true"
                      style="padding: 0px 12px"
                    >
                      <template #default="{ item, i }">
                        <div class="d-flex flex-column pl-2 py-2 lesson">
                          <div class="d-flex justify-content-between">
                            <strong style="min-width: 55px;"
                              >Aula {{ i + 1 }}:</strong
                            >
                            <strong class="ml-3 overflow-hidden text-right">{{
                              item.name
                            }}</strong>
                          </div>
                          <div class="d-flex justify-content-between">
                            <span class="mr-3">Último acesso:</span>
                            <strong>{{ item.progress.last_access }}</strong>
                          </div>
                          <div
                            class="d-flex justify-content-between align-items-center"
                          >
                            <span class="mr-3">Progresso:</span>
                            <div
                              class="d-flex align-items-center text-left pt-2"
                              :class="{
                                completed: item.progress.status === 'Completo',
                                ongoing: item.progress.status === 'Em andamento'
                              }"
                            >
                              {{ item.progress.status }}
                            </div>
                          </div>
                        </div>
                      </template>
                    </data-table>
                  </b-collapse>
                </li>
              </ul>
            </div>
          </b-collapse>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import ProductDropdown from "@/components/product/ProductDropdown";
import CircleProgress from "@/components/product/students/CircleProgress.vue";
import { mapState } from "vuex";
export default {
  components: {
    ProductDropdown,
    CircleProgress
  },
  data() {
    return {
      columns: ["Aulas", "Último acesso", "Progresso"],
      loading: false,
      modules: []
    };
  },
  props: {
    selectedStudent: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState("product", ["product"])
  },
  mounted() {
    this.loading = true;
    this.$store
      .dispatch("membersStudents/getProgressDetails", {
        student_id: this.selectedStudent.user_id,
        product_id: this.$route.params.id
      })
      .then(response => {
        this.modules = response.data;
      })
      .finally(() => (this.loading = false));
  },
  methods: {
    apply() {
      this.$emit("input", this.is_enable);
      this.$emit("submit");
      this.$emit("close");
    },
    clear() {
      this.is_enable = "";
      this.apply();
    }
  }
};
</script>
<style lang="scss" scoped>
.member-area-product-students-progress {
  h6 {
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 28px;
    color: #3b3b4ae5;
  }
  ::v-deep.component-product-dropdown {
    .product-picture {
      width: 32px;
      height: 32px;
    }
    h5 {
      font-size: 14px;
      color: rgba(59, 59, 74, 0.9);
      line-height: 24px;
    }
    strong {
      font-weight: 400;
    }
    .actions-dropdown {
      display: none;
    }
    .text-secondary.text-left.mr-3 {
      display: none;
    }
    .d-flex.flex-column.justify-content-center.align-items-start.mr-5 {
      display: flex !important;
      flex-direction: row !important;
      align-items: center !important;
      justify-content: space-between !important;
      width: 100%;
    }
  }

  .progress {
    height: 0.5rem;
    background-color: rgba(219, 221, 230, 0.85);
  }

  ::v-deep.progress-bar {
    background-color: rgba(184, 136, 255, 0.86);
  }

  ul {
    list-style-type: none;
    padding-left: 0;
  }

  li {
    border-bottom: 1px solid rgba(208, 209, 221, 0.852);
    padding-bottom: 8px;
    padding-top: 8px;
    transition: 0.5s content;
    font-size: 14px;
    font-weight: normal;

    & div#dropdown-label::before {
      font: var(--fa-font-solid);
      color: rgba(87, 88, 107, 0.88);
      margin-right: 16px;
      margin-left: 12px;
      content: "\f078";
    }
    & div#dropdown-label.not-collapsed::before {
      font: var(--fa-font-solid);
      color: rgba(87, 88, 107, 0.88);
      margin-right: 16px;
      margin-left: 12px;
      content: "\f077";
    }

    &:has(div.submodule) {
      &:has(div.not-collapsed) {
        li:first-child {
          &:has(div.not-collapsed) {
            border-bottom: none;
          }
        }
      }
    }
    &:has(div.not-collapsed:not(.submodule)) {
      background: rgba(105, 106, 126, 0.02);
    }
  }

  .submodule {
    height: 32px;
    color: rgba(87, 88, 107, 0.88);
    font-weight: 300;
  }

  .submodule-table {
    padding: 0 32px;
  }
  ::v-deep .data-table.new-design {
    padding-top: 0px !important;
    @media screen and (max-width: 991px) {
      padding-bottom: 4px !important;
    }
    .text-head {
      color: rgba(155, 157, 176, 0.86) !important;
      font-weight: normal !important;
    }
    .border-bottom {
      @media screen and (min-width: 991px) {
        border-bottom: none !important;
      }
    }
    .table-body {
      @media screen and (min-width: 991px) {
        padding-bottom: 4px;
        border-bottom: 1px solid rgba(208, 209, 221, 0.852);
      }
    }
  }
  .completed {
    color: rgba(0, 107, 32, 0.88);
  }
  .ongoing {
    color: rgba(202, 94, 0, 0.868);
  }
  .lesson {
    color: rgba(155, 157, 176, 0.86);
    font-weight: 300;
    line-height: 20px;
    strong {
      color: rgba(119, 120, 142, 0.87);
      font-weight: 300;
    }
  }
}
</style>
